/**
 * Mortgage Calculator for residential and commercial
 *
 *  SDLT(England/NI),
 *  LBTT(Scotland),
 *  LTT(Wales),
 *  Stamp Duty(Ireland)
 *
 * To amend the mortgage calculator based on the Irish Market.
 * calculations are rounded down in line with
 *
 * Reference Link -https://www.sherryfitz.ie/mortgage-calculator  &  https://www.firsthomescheme.ie/guidesresources/ 
 *
 */

const {
  sdltBands,
  countries: {
    IRELAND,
    WALES,
    ENGLAND
  },
  buyerTypes: {
    FIRST_TIME,
    INVESTOR
  },
  propertyTypes: {
    RESIDENTIAL
  },
  comments,
  englandFirstTimeLimit,
  taxNames
} = require('./config');
const ok = 'ok';

/**
 * returns JSON object
 *
 * @param {number} propertyValue - int or floating point.
 * @param {string} propertyType - either propertyTypes.COMMERCIAL or propertyTypes.RESIDENTIAL.
 * @param {string} country - any of countries.ENGLAND, countries.WALES, countries.SCOTLAND, countries.IRELAND
 * @param {string} buyerType - any of buyerTypes.FIRST_TIME, buyerTypes.INVESTOR, buyerTypes.MOVING_HOUSE
 */

//  buyer_section
//  build_section
//  scheme_section
//  help_scheme_section
//  council_section
//  price_section
//  rebate_section
//  first_available_section
//  rate_term_section
//      rate_section
//      term_section

const mortgage_calculate = event => {
  return {
    "countries": "test"
  };
};
module.exports = mortgage_calculate;
const showHideFields = (event, setBuyerToggle, setBuildToggle, setSchemeToggle, setHelpSchemeToggle, setCouncilToggle, setPriceToggle, setRebateToggle, setFirstHomeSchemeToggle, setRateTermToggle, setRateToggle, setTermToggle, setLoanToggle, setDepositToggle, buyerToggle) => {
  console.log(buyerToggle);
  if (event.target.name === "buyerType" || event.target.name === "buildType") {
    if (event.target.value == "Yes") {
      setSchemeToggle(true);
      setHelpSchemeToggle(true);
      // setDepositToggle(true);
      // setLoanToggle(true);
      // setRateTermToggle(true);
      // setRateToggle(true);
      // setTermToggle(true);
    } else {
      setSchemeToggle(false);
      setHelpSchemeToggle(false);
      // setDepositToggle(false);
      // setLoanToggle(false);
      // setRateTermToggle(false);
      // setRateToggle(false);
      // setTermToggle(false);
      // setHelpSchemeToggle(false);
      // setHelpSchemeToggle(false);
    }
  } else {}
  return {
    "countries": "test"
  };
};
// module.exports = showHideFields;

const calculatePrinciple = (propertyValue, interestRate, downPayment, loanTerm) => {
  // const monthlyRate = interestRate / 100 / 12;
  const monthlyRate = interestRate / 1200;
  const payments = 12 * loanTerm;
  const x = Math.pow(1 + monthlyRate, payments);
  let newmortgageAmount = propertyValue - downPayment;
  var monthlyRates = newmortgageAmount * (monthlyRate * Math.pow(monthlyRate + 1, payments) / (Math.pow(monthlyRate + 1, payments) - 1));

  //var calculate_principle = roundNumber(((propertyValue - (propertyValue * downPayment) / 100) * x * monthlyRate) / (x - 1));
  var calculate_principle = roundNumber((propertyValue - downPayment) * x * monthlyRate / (x - 1));

  // var monthlyInterestRate =  interestRate/1200;
  // var numberOfPayments = 12*mortgageTerm;
  // var monthlyRate = newmortgageAmount*(monthlyInterestRate*Math.pow(monthlyInterestRate+1, numberOfPayments)/(Math.pow(monthlyInterestRate+1, numberOfPayments)-1));

  return calculate_principle;
};
const calculateHouseHoldSalary = (loanAmount, buyerType) => {
  const result = parseInt(buyerType == "Yes" ? loanAmount / 4 : loanAmount / 3.5);
  return result;
};
const calculateMonthlyPayment = (propertyValue, interestRate, downPayment, loanTerm) => {
  var calculate_payment = roundNumber(calculatePrinciple(propertyValue, interestRate, downPayment, loanTerm));
  return calculate_payment;
};
const roundNumber = num => {
  return Math.round(num * 100) / 100;
};
const PMT = (rate, periods, present, future, type) => {
  // Credits: algorithm inspired by Apache OpenOffice

  // Initialize type
  var type = typeof type === 'undefined' ? 0 : type;

  // Evaluate rate (TODO: replace with secure expression evaluator)
  rate = eval(rate);

  // Return payment
  var result;
  if (rate === 0) {
    result = (present + future) / periods;
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
    } else {
      result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
    }
  }
  //return -result;
  return result;
};
const FV = (rate, periods, payment, value, type) => {
  // Credits: algorithm inspired by Apache OpenOffice

  // Initialize type
  var type = typeof type === 'undefined' ? 0 : type;

  // Evaluate rate (TODO: replace with secure expression evaluator)
  rate = eval(rate);

  // Return future value
  var result;
  if (rate === 0) {
    result = value + payment * periods;
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
    } else {
      result = value * term + payment * (term - 1) / rate;
    }
  }
  //return -result;
  return result;
};
const IPMT = (rate, period, periods, present, future, type) => {
  // Credits: algorithm inspired by Apache OpenOffice

  // Initialize type
  var type = typeof type === 'undefined' ? 0 : type;

  // Evaluate rate and periods (TODO: replace with secure expression evaluator)
  rate = eval(rate);
  periods = eval(periods);

  // Compute payment
  var payment = PMT(rate, periods, present, future, type);

  // Compute interest
  var interest;
  if (period === 1) {
    if (type === 1) {
      interest = 0;
    } else {
      //interest = -present;
      interest = present;
    }
  } else {
    if (type === 1) {
      interest = FV(rate, period - 2, payment, present, 1) - payment;
    } else {
      interest = FV(rate, period - 1, payment, present, 0);
    }
  }

  // Return interest
  return interest * rate;
};
const updateCalculationResults = args => {
  //If first time buyer is yes percent = 10
  let depPercent = 10;
  //If first time buyer is no percent = 20
  if (args.buyerType == "No") {
    depPercent = 10;
    //Inital deposit set
  }
  let propAmt = parseInt(args.purchasePrice.replace(/[^\d.-]/g, '')); // property amount setup
  let depAmt = percentage(propAmt, depPercent); // get deposit amount
  let firstSchemeAmt = 0; // initiate first scheme amount
  let rebateAmt = 0; // initiate rebate amount
  let response = {
    limitError: false,
    loanToggle: true,
    depositToggle: true,
    priceLimitToggle: true,
    firstHomeSchemeToggle: true,
    warningMsg: '',
    propAmt: propAmt,
    deposit: depAmt,
    firstSchemeAmt: firstSchemeAmt,
    rebateAmt: rebateAmt
  };
  // The minimum property values is 100000
  if (propAmt >= 100000) {
    //Show the loan and deposit section
    // setLoanToggle(true)
    // setDepositToggle(true)          
    // hide price limit warning message
    // setPriceLimitToggle(false); 
    response.priceLimitToggle = false;
    if (args.firstHome == "Yes") {
      let concilPrice = 0;
      if (args.propertyType === "house" || args.propertyType == "all") {
        concilPrice = parseInt(args.concilHomePrice);
      } else if (args.propertyType === "apartment") {
        concilPrice = parseInt(args.concilAptPrice);
      }
      //Show warning message if price exceeds
      if (concilPrice < parseInt(propAmt) && concilPrice != 0) {
        firstSchemeAmt = 0;
        if (parseInt(propAmt) <= 500000) {
          depAmt = depAmt - args.maxRebate > 0 ? depAmt - args.maxRebate : 0;
          rebateAmt = depAmt > args.maxRebate ? depAmt : args.maxRebate;
          if (parseInt(propAmt) <= 300000) {
            //rebate limit
            rebateAmt = percentage(parseInt(propAmt), depPercent);
          }
        } else {
          depAmt = percentage(parseInt(propAmt), depPercent);
          rebateAmt = 0;
          // if(parseInt(val) <= 300000){ //rebate limit
          //     rebateAmt=percentage(parseInt(val), depositPercentage);
          //   } 
        }
        response.warningMsg = 'PRICE EXCEEDS COUNCIL MAX (' + args.currency_symbol + '' + numberFormat(concilPrice) + ')';
        response.priceLimitToggle = true;
        response.limitError = true;
        // setFirstHomeSchemeToggle(false)
      } else {
        response.firstHomeSchemeToggle = true;
        if (args.propertyType == "all") {
          if (parseInt(propAmt) <= 500000) {
            depAmt = depAmt - args.maxRebate > 0 ? depAmt - args.maxRebate : 0;
            // rebateAmt= depAmt > maxRebate ? depAmt : maxRebate  ;          
            if (parseInt(propAmt) <= 300000) {
              //rebate limit                  
              rebateAmt = percentage(parseInt(propAmt), 10);
            } else {
              rebateAmt = depAmt > args.maxRebate ? depAmt : args.maxRebate;
            }
            if (args.councilType == "all") {
              firstSchemeAmt = 0;
            } else {
              if (concilPrice >= parseInt(propAmt) && concilPrice != 0) {
                if (args.helpScheme) {
                  firstSchemeAmt = percentage(parseInt(propAmt), 20);
                } else {
                  firstSchemeAmt = percentage(parseInt(propAmt), 30);
                }
              } else {
                firstSchemeAmt = 0;
              }
            }
          } else {
            firstSchemeAmt = 0;
            rebateAmt = 0;
          }
        } else {
          depAmt = depAmt - args.maxRebate > 0 ? depAmt - args.maxRebate : 0;
          rebateAmt = depAmt > args.maxRebate ? depAmt : args.maxRebate;
          if (args.helpScheme) {
            firstSchemeAmt = propAmt * 20 / 100;
          } else {
            firstSchemeAmt = propAmt * 30 / 100;
          }
          if (propAmt <= 300000) {
            //rebate limit                  
            rebateAmt = percentage(propAmt, 10);
          } else {
            rebateAmt = depAmt > args.maxRebate ? depAmt : args.maxRebate;
          }
        }
      }
      if (!args.helpScheme) {
        depAmt = percentage(propAmt, depPercent);
        rebateAmt = 0;
      }
      // help condition       
    } else {
      if (args.helpScheme) {
        if (propAmt <= 500000) {
          // price limit
          depAmt = depAmt - args.maxRebate > 0 ? depAmt - args.maxRebate : 0;
          firstSchemeAmt = 0;
          rebateAmt = depAmt > args.maxRebate ? depAmt : args.maxRebate;
          if (parseInt(propAmt) <= 300000) {
            //rebate limit
            rebateAmt = percentage(propAmt, depPercent);
          }
        } else {
          firstSchemeAmt = 0;
          rebateAmt = 0;
        }
      } else {
        firstSchemeAmt = 0;
      } // help condition    
    } // firsthome condition  

    response.deposit = depAmt;
    response.schemeAmount = firstSchemeAmt;
    response.rebateAmt = rebateAmt;
    //update price section values 
    let loan = propAmt - (parseInt(depAmt) + parseInt(firstSchemeAmt) + parseInt(rebateAmt));
    //Result section-------
    response.loan = loan;
    response.monthlyPayment = calculateMonthlyPayment(parseInt(propAmt - firstSchemeAmt), parseFloat(args.interest), parseInt(parseInt(depAmt) + parseInt(rebateAmt)), args.duration); // monthly payment set     
    response.houseHoldSalary = calculateHouseHoldSalary(loan); // salary set
  } else {
    //If less than the 100000 show warning messages
    // update warning message nd show
    response.limitError = true;
    response.loanToggle = true;
    response.depositToggle = true;
    response.priceLimitToggle = true;
    response.firstHomeSchemeToggle = true;
    response.warningMsg = "VALUE MUST BE AT LEAST €100,000";
    response.propAmt = true;
    response.deposit = 0;
    response.firstSchemeAmt = 0;
    response.rebateAmt = 0;
    response.loan = 0;
    response.monthlyPayment = 0;
    response.houseHoldSalary = 0;
  } // limit validation
  // Load with number format
  return response;
};
const percentage = (a, b) => {
  var c = parseFloat(a) * parseFloat(b) / 100;
  return parseFloat(c);
};

/**
 * number
 */
const numberFormat = num => {
  if (!num) return 0;
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format
  return new Intl.NumberFormat("en-US", {}).format(num);
};

/**
 * parseInt
 */
const filterNumber = str => {
  if (!str) return 0;
  str = str.toString();
  return parseInt(str.replace(/[^\d.]/g, ""), 10);
};

/**
 * Interest rate, periods, Present value of loan, Future value of loan, Calculated at start of each period
 */
const pmt = function (rate, periods, present) {
  let future = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  if (isNaN(rate) || isNaN(periods) || !periods || !rate) {
    return 0;
  }
  if (rate === 0) {
    return -((present + future) / periods);
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      return -((future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate));
    } else {
      return -(future * rate / (term - 1) + present * rate / (1 - 1 / term));
    }
  }
};
module.exports = {
  calculatePrinciple,
  // mortgage_calculate,
  showHideFields,
  IPMT,
  FV,
  PMT,
  roundNumber,
  calculateMonthlyPayment,
  calculateHouseHoldSalary,
  updateCalculationResults,
  numberFormat,
  filterNumber,
  pmt,
  percentage
};